import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { FinParcours } from '../référentiel-métier-parcours/models/fin-parcours.model';
import { FinParcoursStore } from '../référentiel-métier-parcours/store/fin-parcours/fin-parcours.store';

export const finParcoursResolver: ResolveFn<FinParcours | undefined> = (route) => {
  const finParcoursStore = inject(FinParcoursStore);
  const id = route.queryParamMap.get('id');
  const type = route.queryParamMap.get('type');

  if (!id || type !== 'fin-parcours') {
    return undefined;
  }
  finParcoursStore.select({ id });
  return finParcoursStore.selectedEntity()!;
};
